module.exports = __webpack_public_path__ + "static/img/icon-contactus.972d0f36.svg";